import "./style/index.css?global";
import "../button/style/index.css?global";
import { Input } from "antd";
import Copyable from "./copyable";
export default Object.assign(Input, {
  Copyable
});